import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";
export default {
  name: "MemberOto",
  components: {
    EmptyNew: EmptyNew
  },
  data: function data() {
    return {
      current: "1",
      types: [{
        type: "1",
        label: "待上课"
      }, {
        type: "2",
        label: "已上课"
      }, {
        type: "3",
        label: "已取消"
      }],
      page: 1,
      limit: 10,
      total: 0,
      list: [],
      showCommentDialog: false,
      commentItem: {},
      commentInfo: {},
      commentForm: {
        grade: 5,
        tag: {},
        content: ""
      }
    };
  },
  watch: {
    current: function () {
      var _current = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.page = 1;
                this.list = [];
                _context.next = 4;
                return this.getData();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function current() {
        return _current.apply(this, arguments);
      }

      return current;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getData();

            case 2:
              triggerLoaded(this);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$http.post("/api/app/oto/myInviteCourse/index", {
                  type: this.current,
                  limit: this.limit,
                  page: this.page
                });

              case 2:
                data = _context3.sent;
                data.data.forEach(function (o) {
                  _this.list.push(o);
                });
                this.total = data.total;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    loadMore: function () {
      var _loadMore = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.page++;
                _context4.next = 3;
                return this.getData();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadMore() {
        return _loadMore.apply(this, arguments);
      }

      return loadMore;
    }(),
    cancelOto: function () {
      var _cancelOto = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(item) {
        var time;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(item.apply_refund == 1)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", this.$info("您已经提交取消约课申请了，请耐心等待管理审核"));

              case 2:
                time = new Date(item.start_play * 1000).format("yyyy-MM-dd hh:mm") + "-" + new Date(item.end_play * 1000).format("hh:mm");
                _context5.next = 5;
                return this.$promiseConfirm("取消课程后，资金将原路返回您的账户。确认取消" + item.nickname + "   " + time + "   的约课么？", {
                  type: "warning",
                  cancelButtonText: "再想想",
                  confirmButtonText: "确定取消"
                });

              case 5:
                _context5.next = 7;
                return this.$http.get("/api/app/oto/cancelInvite/" + item.id + "/0");

              case 7:
                this.list = [];
                this.page = 1;
                _context5.next = 11;
                return this.getData();

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function cancelOto(_x) {
        return _cancelOto.apply(this, arguments);
      }

      return cancelOto;
    }(),
    beginComment: function () {
      var _beginComment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(item) {
        var _this2 = this;

        var data, tagIds;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.commentForm.tag = {};
                _context6.next = 3;
                return this.$http.get("/api/app/oto/comment/info/" + item.id);

              case 3:
                this.commentInfo = _context6.sent;
                this.commentInfo.tag.forEach(function (t) {
                  _this2.$set(_this2.commentForm.tag, t.id, 0);
                });

                if (!(item.is_comment > 0)) {
                  _context6.next = 15;
                  break;
                }

                _context6.next = 8;
                return this.$http.post("/api/app/oto/comment/send", {
                  teacher_id: item.teacher_id,
                  user_id: item.user_id,
                  oto_course_id: item.id,
                  comment_id: item.is_comment
                });

              case 8:
                data = _context6.sent;
                this.commentForm.grade = data.grade;
                this.commentForm.content = data.content;
                tagIds = data.tag_id.split(",");
                tagIds.forEach(function (t) {
                  _this2.commentForm.tag[t] = 1;
                });
                _context6.next = 17;
                break;

              case 15:
                this.commentForm.grade = 5;
                this.commentForm.content = "";

              case 17:
                this.commentItem = item;
                this.showCommentDialog = true;

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function beginComment(_x2) {
        return _beginComment.apply(this, arguments);
      }

      return beginComment;
    }(),
    toggleSelected: function toggleSelected(id) {
      if (this.commentItem.is_comment > 0) {
        return;
      }

      if (this.commentForm.tag[id] == 0) {
        this.commentForm.tag[id] = 1;
      } else {
        this.commentForm.tag[id] = 0;
      }
    },
    submitComment: function () {
      var _submitComment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var tagIds, key, data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.commentItem.comment_id > 0)) {
                  _context7.next = 3;
                  break;
                }

                this.showCommentDialog = false;
                return _context7.abrupt("return");

              case 3:
                if (!(this.commentForm.grade == 0)) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 6;
                return this.$info("请选择星级");

              case 6:
                return _context7.abrupt("return");

              case 7:
                tagIds = [];

                for (key in this.commentForm.tag) {
                  if (this.commentForm.tag[key] == 1) {
                    tagIds.push(key);
                  }
                }

                if (!(tagIds.length == 0)) {
                  _context7.next = 13;
                  break;
                }

                _context7.next = 12;
                return this.$info("请选择标签");

              case 12:
                return _context7.abrupt("return");

              case 13:
                if (!(this.commentForm.content == "")) {
                  _context7.next = 17;
                  break;
                }

                _context7.next = 16;
                return this.$info("请输入评价内容");

              case 16:
                return _context7.abrupt("return");

              case 17:
                _context7.next = 19;
                return this.$http.post("/api/app/oto/comment/send", {
                  teacher_id: this.commentItem.teacher_id,
                  user_id: this.commentItem.user_id,
                  content: this.commentForm.content,
                  grade: this.commentForm.grade,
                  oto_course_id: this.commentItem.id,
                  tag_id: tagIds.join(","),
                  comment_id: 0
                });

              case 19:
                data = _context7.sent;
                this.commentItem.is_comment = data.comment_id;
                this.showCommentDialog = false;
                _context7.next = 24;
                return this.$success("评价成功");

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function submitComment() {
        return _submitComment.apply(this, arguments);
      }

      return submitComment;
    }(),
    enterLive: function () {
      var _enterLive = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(id) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.$livePlay(id, 1, {
                  title: "一对一"
                });

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function enterLive(_x3) {
        return _enterLive.apply(this, arguments);
      }

      return enterLive;
    }(),
    onDownload: function onDownload(item) {
      if (item.file_url) {
        this.$pub.downloadFile(item.file_url, item.file_name);
      } else {
        window.open(item.preview_url);
      }
    }
  }
};